<!--
    描述：项目管理-- 聚易厅项目-- 查看详情页 第一个tab项（项目基本信息）
    时间：2022-05-07
    Created by 何伟
-->
<template>
  <div class="pro-baseinfo-main">
    <!-- :class="{ h100: audit === 'audit' }" -->
    <div class="expert-content">
      <el-form
        :model="juyiProjectMsg"
        label-width="170px"
        size="small"
        ref="personForm"
        :show-message="false"
      >
        <el-row class="mb20">
          <el-col :span="24">
            <h3>{{ juyiProjectMsg.sname }}</h3>
          </el-col>
        </el-row>
        <el-row>
          <div class="numblerbox">
            <div
              class="numblerboxItem"
              v-for="(item, index) in progresslist"
              :key="'progresslist' + index"
            >
              <div class="itembox">
                <span
                  :class="['number', item.arise == 1 ? 'blue-bg' : 'gray-bg']"
                  >{{ index + 1 }}</span
                >
                <span
                  :class="['line', item.arise == 1 ? 'blue-line' : 'gray-line']"
                ></span>
              </div>
              <div style="" class="descbox">
                <div class="dec-text md5">
                  {{ item.desc }}
                </div>
                <div class="dec-text" v-if="item.arise == 1">
                  {{ item.createDate | dateFilter }}
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <span slot="label">
                <span class="blacktext">当前状态：</span>
              </span>
              <div class="bluetext">{{ currentState }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="最新动态：">
              <span class="bluetext">
                {{
                  newescreateDate
                    ? newescreateDate.substring(0, 16) +
                      "&nbsp&nbsp&nbsp" +
                      newescontent
                    : ""
                }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目类型：">
              {{
                juyiProjectMsg.projectTypeName +
                "/" +
                juyiProjectMsg.subTypeName
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传附件资料：">
              <div class="beyondHiding">
                  <div
                      v-for="(item, index) in juyiProjectMsg.sysFiles"
                      :key="index"
                      class="link mr10"
                      type="text"
                      @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                  >
                    <span slot="reference">{{ item.fileName }}</span>
<!--                    <el-popover
                        placement="top-start"
                        title="文件"
                        trigger="hover"
                    >
                      <div
                          v-for="e in juyiProjectMsg.sysFiles"
                          class="link"
                          :key="e.id"
                          @click="viewFile(e.fullFilePath)"
                      >
                        {{ e.fileName }}
                      </div>
                      <span slot="reference">{{ item.fileName }}</span>
                    </el-popover>-->
                  </div>
              </div>
<!--
              <my-upload
                ref="cns"
                :aid="juyiProjectMsg.id"
                :maxNum="1"
                :tableName="'business_expand_juyi'"
                mode="view"
                forDatabase="project_audit"
                :isDisabled="true"
              >
              </my-upload>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目描述：">
              {{ juyiProjectMsg.description }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布类型：">
              {{ juyiProjectMsg.pubType === 0 ? "众包" : "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许投标人数：">
              {{
                juyiProjectMsg.allowBids ? juyiProjectMsg.allowBids + "人" : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="竞价模式：">
              {{ juyiProjectMsg.bidMode === 0 ? "一口价" : "可议价" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报名截止时间：">
              <span class="redtext">{{
                juyiProjectMsg.registrationDeadline
                  ? juyiProjectMsg.registrationDeadline.substring(0, 16)
                  : ""
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目地址：">
              {{
                juyiProjectMsg.projectProvinceName +
                juyiProjectMsg.projectCityName +
                juyiProjectMsg.projectAreaName
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">
              {{ juyiProjectMsg.detailAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="雇主报价：">
              {{
                juyiProjectMsg.employerOffer
                  ? juyiProjectMsg.employerOffer
                      .toFixed(2)
                      .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,") + "元"
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望最终交付日期：">
              {{
                juyiProjectMsg.exDelDate
                  ? juyiProjectMsg.exDelDate.substring(0, 10)
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分期托管资金：">
              {{ juyiProjectMsg.stageFlag === 0 ? "否" : "是" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="需要投标方缴纳保证金：">
              {{ juyiProjectMsg.depositFlag === 0 ? "否" : "是" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="雇主方：">
              {{ juyiProjectMsg.publisherName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需要开票：">
              {{ juyiProjectMsg.invoiceFlag === 0 ? "否" : "是" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建筑面积：">
              {{
                juyiProjectMsg.structureArea
                  ? juyiProjectMsg.structureArea
                      .toFixed(0)
                      .replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,") +
                    "平方米"
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人手机号：">
              {{ juyiProjectMsg.linkPhone }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="movetype">
      <h3>项目动态</h3>
      <div v-if="!iscloseMove" class="m-timeline-area">
        <div class="m-timeline">
          <div
            :class="['m-timeline-item', { last: n === timelineDesc.length }]"
            v-for="n in timelineDesc.length"
            :key="n"
          >
            <div class="u-tail"></div>
            <div class="u-dot">
              <div class="out-circle">
                <div class="in-circle"></div>
              </div>
            </div>
            <div class="u-content">
              <div>
                <p class="textB">{{ timelineDesc[n - 1].time }}</p>
                <p
                  class="textL"
                  v-for="t in timelineDesc[n - 1].dynamics"
                  :key="t.id"
                >
                  {{ t.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="closebox" @click="clickCloseMove">
        <div class="closeArrow">
          <i class="el-icon-arrow-up" v-if="!iscloseMove"></i>
          <i class="el-icon-arrow-down" v-else></i>
        </div>
        <div class="text">
          {{ iscloseMove == false ? "收起动态" : "展开动态" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selectProjectById,
  getStageRecords,
  getDynamicList,
  getSubProjectInfo,
} from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), "yyyy-MM-dd");
    },
  },
  data() {
    return {
      currentState: "", //当前状态
      iscloseMove: false, //控制项目动态是否显示
      newescontent: "", //最新动态 内容，
      newescreateDate: "", //最新动态 时间
      progresslist: [], // 进度条数据
      juyiProjectMsg: {
        id: "",
        baseId: "",
        businessId: "",
        sname: "",
        projectTypeName: "",
        subTypeName: "",
        description: "",
        pubType: "",
        allowBids: "",
        bidMode: "",
        registrationDeadline: "",
        projectProvinceName: "",
        projectCityName: "",
        projectAreaName: "",
        detailAddress: "",
        employerOffer: "",
        exDelDate: "",
        stageFlag: "",
        depositFlag: "",
        structureArea: "",
        linkPhone: "",
        createDate: "",
      },
      auditType: "1", //tab项当前值
      timelineDesc: [], //项目动态数据
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "juyi-project-list",
      });
      return;
    }
    //数据加载
    this.selectProjectById(); //项目详情
    this.getStageRecords(); //项目阶段记录
    this.getDynamicList(); //项目动态
    this.getSubProjectInfo(); //项目当前状态
  },
  methods: {
    //控制项目动态是否显示
    clickCloseMove() {
      this.iscloseMove = !this.iscloseMove;
    },
    //查询详情页-项目阶段记录
    getStageRecords() {
      getStageRecords({
        subProjectId: this.rowData.businessId,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.progresslist = res.data;
        }
      });
    },
    //查询详情页-项目动态
    getDynamicList() {
      getDynamicList({
        subProjectId: this.rowData.businessId,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.timelineDesc = res.data.dynamicList;
          this.newescontent = res.data.newestDynamic.content;
          this.newescreateDate = res.data.newestDynamic.createDate;
        }
      });
    },
    //获取项目当前状态
    getSubProjectInfo() {
      getSubProjectInfo({
        id: this.rowData.businessId,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.currentState = res.data.projectStatusText;
        }
      });
    },
    //获取聚易厅项目
    selectProjectById() {
      selectProjectById({
        id: this.rowData.id,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.juyiProjectMsg = res.data;
        }
      });
    },
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName)
    },
  },
};
</script>
<style scoped lang="less">
.pro-baseinfo-main {
  // height: 100%;

  .juyihead {
    padding: 15px 15px;
    /deep/.el-tabs__item {
      width: 130px;
    }
  }
  .header-note {
    height: 34px;
    line-height: 34px;
    padding: 0 13px;
    border: 1px solid #fbcdd1;
    font-size: 12px;
    color: #e60012;
    background: #fde6e6;
    margin-bottom: 13px;
  }

  .expert-content {
    background-color: #fff;
    padding: 20px;
    height: calc(~"100% - 210px - 20px");
    overflow-y: auto;
    .numblerbox {
      padding: 20px 80px;
      display: flex;
      .numblerboxItem {
        .itembox {
          margin-bottom: 10px;
          .number {
            display: inline-table;
            // border-radius: 14px;
            border-radius: 50%;
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            vertical-align: middle;
          }
          .blue-bg {
            background-color: #199ed8;
            color: #fff;
          }
          .gray-bg {
            background-color: #eee;
            color: #999;
          }
          .line {
            margin: 0 4px;
            display: inline-block;
            // width: 135px;
            width: 120px;
            height: 2px;
          }
          .blue-line {
            border-top: 1px solid #199ed8;
          }
          .gray-line {
            border-top: 1px solid #999;
          }
        }
        .descbox {
          text-align: center;
          //margin-left: -140px;
          margin-left: -125px;
          .dec-text {
            font-size: 14px;
          }
          .md5 {
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  // /* 时间线 */
  .movetype {
    border-top: 1px solid #2671cb;
    padding: 0px 17px;
    padding-top: 20px;
    @blue: #1890ff;
    @green: #52c41a;
    @red: #f5222d;
    @gray: rgba(0, 0, 0, 0.25);
    .m-timeline-area {
      margin: 30px auto;
      margin-bottom: 0;
      .m-timeline {
        .m-timeline-item {
          position: relative;
          padding-bottom: 30px;
          .u-tail {
            position: absolute;
            // top: 10px;
            top: 20px;
            left: 7px;
            height: calc(100% - 25px);
            border-left: 2px solid #e8e8e8; // 实线
            // border-left: 2px dotted #e8e8e8; // 点线
            // border-left: 2px dashed #e8e8e8; // 虚线
          }
          .u-dot {
            .out-circle {
              width: 16px;
              height: 16px;
              background: rgba(14, 116, 218, 0.1);
              box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
              /*opacity: 0.1;*/
              border-radius: 50%;
              display: flex;
              align-items: center;

              .in-circle {
                width: 8px;
                height: 8px;
                margin: 0 auto;
                background: rgba(14, 116, 218, 1);
                border-radius: 50%;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
              }
            }

            // position: absolute;
            // width: 8px;
            // height: 8px;
            // border: 2px solid @blue;
            // border-radius: 50%;
          }
          .u-content {
            position: relative;
            top: -20px;
            // top: -6px;
            margin-left: 25px;
            word-break: break-word;
            line-height: 24px;
            font-size: 14px;
            .textB {
              font-weight: 600;
            }
            .textL {
              color: #666;
            }
          }
        }
        .last {
          .u-tail {
            display: none;
          }
        }
      }
    }

    .closebox {
      text-align: center;
      .closeArrow {
        font-size: 40px;
        color: #ff9933;
        i {
          font-weight: 600;
        }
      }
      .text {
        margin-top: -10px;
        font-size: 12px;
        color: #666;
        letter-spacing: 2px;
      }
    }
  }
}
.bluetext {
  color: #0000ff;
  font-weight: 600;
}
.blacktext {
  color: #000;
  font-weight: 600;
}
.redtext {
  color: #ff0000;
}
</style>
